// extracted by mini-css-extract-plugin
module.exports = {"layout":"AboutCard_layout__1Yk4_"};